import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function SolutionSection() {
  const shields = [{
    emoji: '🫐',
    name: 'Blueberries',
    target: 'Brain Shield',
    description: 'Anthocyanins cross the blood-brain barrier to neutralize oxidative stress and prevent cognitive decline.'
  }, {
    emoji: '🐟',
    name: 'Sardines',
    target: 'Heart Shield',
    description: 'Bioavailable EPA/DHA omega-3s reduce systemic chronic inflammation by up to 40%.'
  }, {
    emoji: '🥦',
    name: 'Broccoli Sprouts',
    target: 'Detox Shield',
    description: 'Sulforaphane activates the Nrf2 pathway for elite cellular detoxification and cancer defense.'
  }, {
    emoji: '💧',
    name: 'Filtered Water',
    target: 'Kidney Shield',
    description: 'Remove fluoride, chlorine, and heavy metals that silently destroy renal function over time.'
  }];
  return <section className="py-20 md:py-28 px-6 bg-deep" data-id="element-133">
      <div className="max-w-7xl mx-auto" data-id="element-134">
        <FadeIn className="text-center mb-16" data-id="element-135">
          <h3 className="uppercase tracking-[0.3em] text-amber text-sm font-semibold mb-4" data-id="element-136">
            THE SOLUTION
          </h3>
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-137">
            Activate Your Dog's 4 Cellular Shields
          </h2>
          <p className="text-xl text-body max-w-2xl mx-auto" data-id="element-138">
            You don't need a $400/month raw food budget. Just add these specific
            compounds back into their bowl.
          </p>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-5xl mx-auto" data-id="element-139">
          {shields.map((shield, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-140">
              <div className="bg-white/[0.05] backdrop-blur-md border border-white/10 rounded-2xl p-8 hover:border-amber/30 transition-colors h-full flex flex-col" data-id="element-141">
                <div className="flex items-start justify-between mb-6" data-id="element-142">
                  <span className="text-5xl" data-id="element-143">{shield.emoji}</span>
                  <span className="text-xs font-bold uppercase tracking-wider text-muted bg-white/5 px-3 py-1 rounded-full border border-white/10" data-id="element-144">
                    SHIELD
                  </span>
                </div>
                <h4 className="text-2xl font-bold text-amber mb-1" data-id="element-145">
                  {shield.name}
                </h4>
                <p className="text-white font-medium mb-4" data-id="element-146">→ {shield.target}</p>
                <p className="text-body leading-relaxed mt-auto" data-id="element-147">
                  {shield.description}
                </p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}